import React from "react";
import LogoutGIF from "@/assets/images/logout.gif";
import { showSuccess, showError } from "@/shared/utils/toast";
import CustomModal from "@/shared/components/ui/Modal/CustomModal";
import SecondaryButton from "@/shared/components/ui/Button/SecondaryButton";
import { PrimaryButton } from "@/shared/components/ui/Button/PrimaryButton";
import { LogOut, X } from "lucide-react";

const LogoutConfirm = ({ showLogoutConfirm, onClose }) => {
  const handleLogout = () => {
    try {
      // Clear all storage
      localStorage.clear();
      sessionStorage.clear();

      // Clear all cookies
      document.cookie.split(";").forEach((cookie) => {
        const name = cookie.split("=")[0].trim();
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
      });
      showSuccess("Logged out successfully!");
      // Use location.replace to clear protected route from browser back history stack
      window.location.replace("/signup");
    } catch (error) {
      console.error("Error during logout:", error);
      showError("An error occurred during logout");
    }
  };

  return (
    <CustomModal isOpen={showLogoutConfirm} onClose={onClose}>
      <div className="flex justify-end w-full">
        <button className="p-1 hover:bg-gray-100 rounded-full" onClick={onClose}>
          <X size={20} color="#181D27" />
        </button>
      </div>
      <div className="flex flex-col gap-3.5">
        {/* title & description */}
        <div className="flex flex-col gap-1.5 items-center justify-center">
          <img src={LogoutGIF} alt="LogoutGIF" className="h-14 w-14" />
          <h3 className=" text-gray-900 font-bold text-base">
            Are you sure you want to logout?
          </h3>
          <p className=" text-gray-500 text-xs text-center">
            Logging out will close your current session and redirect you to the
            login page.
          </p>
        </div>
        {/* buttons */}
        <div className="flex gap-3.5 mx-2 justify-center">
          <SecondaryButton
            textColor="dark"
            title={"Yes, logout"}
            icon={<LogOut color="#F04438" size={16} />}
            className="w-full"
            onClick={handleLogout}
          />
          <PrimaryButton
            startContent={false}
            className="w-full"
            onClick={onClose}
          >
            Cancel
          </PrimaryButton>
        </div>
      </div>
    </CustomModal>
  );
};

export default LogoutConfirm;
